<template>
  <span
    class="dropdown-header mt-2"
    v-if="checkGuard('create_complaint') || checkGuard('view_complaint')"
    >Dossiers</span
  >
  <small class="bi-three-dots nav-subtitle-replacer"></small>

  <!-- New Dossier -->

  <div class="nav-item" v-if="checkGuard('create_complaint')">
    <a
      class="nav-link dropdown-toggle collapsed"
      href="#navbarVerticalMenuPagesNouveauDossierMenu"
      role="button"
      data-bs-toggle="collapse"
      data-bs-target="#navbarVerticalMenuPagesNouveauDossierMenu"
      aria-controls="navbarVerticalMenuPagesNouveauDossierLink"
      :class="routesActive.new.includes($route.name) ? 'active' : 'collapsed'"
    >
      <i class="bi-layout-text-window nav-icon"></i>
      <span class="nav-link-title">Nouveau dossier</span>
    </a>

    <div
      id="navbarVerticalMenuPagesNouveauDossierMenu"
      :class="routesActive.new.includes($route.name) ? 'show' : ''"
      class="nav-collapse collapse"
      data-bs-parent="#navbarVerticalMenuPagesNouveauDossierLink"
    >
      <router-link
        :to="{ name: 'DossierNewCourrier' }"
        active-class="active"
        class="nav-link"
        >Courrier</router-link
      >

      <router-link
        :to="{ name: 'DossierNewAutosaisine' }"
        active-class="active"
        class="nav-link"
        >Autosaisine</router-link
      >

      <router-link
        :to="{ name: 'DossierNewCallCenter' }"
        active-class="active"
        class="nav-link"
        >Call center
      </router-link>

      <!-- <router-link :to="{ name: 'DossierListFilter', params: { filter: 'to_follow_up' } }" active-class="active"
        class="nav-link">Mes dossiers du jour
      </router-link> -->
    </div>
  </div>
  <div class="nav-item" v-if="checkGuard('view_complaint')">
    <a
      class="nav-link dropdown-toggle"
      href="#navbarVerticalMenuPagesListeDossiersMenu"
      role="button"
      data-bs-toggle="collapse"
      data-bs-target="#navbarVerticalMenuPagesListeDossiersMenu"
      aria-controls="navbarVerticalMenuPagesListeDossiersLink"
      :class="routesActive.list.includes($route.name) ? 'active' : 'collapsed'"
    >
      <i class="bi-stickies nav-icon"></i>
      <span class="nav-link-title">Liste des dossiers</span>
    </a>
    <div
      id="navbarVerticalMenuPagesListeDossiersMenu"
      class="nav-collapse collapse"
      :class="routesActive.list.includes($route.name) ? 'show' : ''"
      data-bs-parent="#navbarVerticalMenuPagesListeDossiersLink"
    >
      <!-- Pour ROLE SANS SUITE (view_closed_only), afficher uniquement "Sans suite" -->
      <template v-if="checkGuard('view_closed_only')">
        <router-link
          :to="{ name: 'DossierListFilter', params: { filter: 'no_follow_up' } }"
          exact-active-class="active"
          class="nav-link"
          >Sans suite</router-link
        >
      </template>

      <!-- Pour les autres utilisateurs, afficher le menu normal -->
      <template v-else>
        <router-link
          :to="{ name: 'DossierListFilter', params: { filter: 'all' } }"
          exact-active-class="active"
          class="nav-link"
          >Tous les dossiers</router-link
        >
        <router-link
          :to="{ name: 'DossierListFilter', params: { filter: 'to_follow_up' } }"
          exact-active-class="active"
          class="nav-link" v-if="checkGuard('view_role')"
          >Non classés</router-link
        >

         <router-link
          :to="{ name: 'DossierListFilter', params: { filter: 'untreat' } }"
          exact-active-class="active"
          class="nav-link" v-else
          >Non traités</router-link
        >
        <router-link
          :to="{ name: 'DossierListFilter', params: { filter: 'no_follow_up' } }"
          exact-active-class="active"
          class="nav-link" v-if="checkGuard('view_role')"
          >Sans suite</router-link
        >

        <router-link
          :to="{ name: 'DossierListFilter', params: { filter: 'internal' } }"
          exact-active-class="active"
          class="nav-link" v-if="checkGuard('view_role')"
          >En traitement interne</router-link
        >

        <router-link
          :to="{ name: 'DossierListFilter', params: { filter: 'close' } }" exact-active-class="active" class="nav-link" v-else>Cloturés</router-link>

        <router-link
          :to="{
            name: 'DossierListFilter',
            params: { filter: 'administration' },
          }"
          exact-active-class="active"
          class="nav-link" v-if="checkGuard('view_role')"
          >En administration</router-link
        >
      </template>

      <div class="nav-item" v-if="checkGuard('view_role')">
        <a
          class="nav-link dropdown-toggle"
          href="#navbarVerticalMenuPagesListeDossiersMenuIA"
          role="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarVerticalMenuPagesListeDossiersMenuIA"
          aria-controls="navbarVerticalMenuPagesListeDossiersMenuIA"
          :class="
            routesActive.list.includes($route.name) ? 'active' : 'collapsed'
          "
        >
          <span class="nav-link-title"
            >Suggestions
            <span class="text-muted"
              >(<i class="bi-robot nav-icon"></i> Foniva IA)</span
            ></span
          >
        </a>
        <div
          id="navbarVerticalMenuPagesListeDossiersMenuIA"
          class="nav-collapse collapse"
          :class="routesActive.list.includes($route.name) ? 'show' : ''"
          data-bs-parent="#navbarVerticalMenuPagesListeDossiersMenuIA"
        >
          <router-link
            :to="{ name: 'iaClassification', params: { filter: 'basse' } }"
            exact-active-class="active"
            class="nav-link"
            >Priorité Basse
          </router-link>
          <router-link
            :to="{ name: 'iaClassification', params: { filter: 'moyenne' } }"
            exact-active-class="active"
            class="nav-link"
            >Priorité Moyenne
          </router-link>
          <router-link
            :to="{ name: 'iaClassification', params: { filter: 'haute' } }"
            exact-active-class="active"
            class="nav-link"
            >Priorité Haute</router-link
          >
        </div>
      </div>
    </div>
  </div>

  <div class="nav-item" v-if="checkGuard('view_user')">
    <router-link
      :to="{ name: 'DossierStatsStatistique' }"
      class="nav-link"
      active-class="active"
      data-placement="left"
    >
      <i class="bi-graph-up nav-icon"></i>
      <span class="nav-link-title">Statistiques</span>
    </router-link>
  </div>
  <div class="nav-item" v-if="checkGuard('view_user')">
    <router-link
      :to="{ name: 'DossierStatsRapport' }"
      class="nav-link"
      active-class="active"
      data-placement="left"
    >
      <i class="bi bi-journal-bookmark-fill nav-icon"></i>
      <span class="nav-link-title">Rapports</span>
    </router-link>
  </div>
</template>

<script>
import { checkGuard } from "@/utils/guards.js";

export default {
  name: "DossierNavbar",
  data() {
    return {
      routesActive: {
        new: [
          "DossierNewCourrier",
          "DossierNewAutosaisine",
          "DossierNewDossierJour",
          "DossierNewCallCenter",
          "iaConversation",
          "iaClassification",
          "iaRapport",
        ],
        stats: ["DossierStatsStatistique"],
        list: ["DossierListFilter", "iaClassification"],
        suggestion: ["iaClassification"],
      },
    };
  },

  methods: {
    checkGuard,
  },
};
</script>
